<script lang="ts" setup>
import { computed, onMounted } from '#imports';
import { declareProviders, useService } from '@kaokei/use-vue-service';
import titleImg from '~/assets/image/index/title/xsrw.svg';
import { UserService } from '~/services/user.service';
import { FRESH_TASK_STATUS, MISSION_TASK_EVENT } from '~/utils/constant';
import ModuleTitle from '../ModuleTitle.vue';
import FreshTaskItem from './FreshTaskItem.vue';
import { FreshTasksService } from './FreshTasks.service';
import GatherInfo from './GatherInfo.vue';

const service = useService(FreshTasksService);
const userService = useService(UserService);
onMounted(() => {
  //主要是首页有挪位置的逻辑，避免避免重复请求
  if (userService.isLogin() && service.noviceTasks?.missionList?.length === 0) {
    service.init();
  }
});
const visible = computed(() => {
  if (!userService.isLogin()) {
    return false;
  }
  if (service.noviceTasks?.missionList?.length === 0) {
    return false;
  }
  if (
    service.noviceTasks?.missionList?.every(
      (item) => item.missionStatus === FRESH_TASK_STATUS.FINISHED,
    )
  ) {
    return false;
  }
  return true;
});
</script>

<template>
  <div
    v-if="visible"
    class="rounded border border-lightblack bg-white p-3 text-sm text-colorTextSecondary"
  >
    <!-- 标题部分 -->
    <div class="flex items-center">
      <ModuleTitle class="w-full">
        <img class="h-[18px]" :src="titleImg" alt="新手任务" />
      </ModuleTitle>
    </div>
    <ul>
      <FreshTaskItem
        v-for="item in service.noviceTasks.missionList"
        :key="item.missionId"
        :item="item"
        :join-training="service.joinTraining"
        @go-compelete-person-info="service.goCompeletePersonInfo"
      />
    </ul>

    <GatherInfo />
  </div>
</template>
